import './App.css'
import  {TodoApp}  from './component/todoApp';
function App() {
  return (
    <div>
      <TodoApp />    
    </div>
  );
}

export default App;
